import PropTypes from "prop-types";

/*
 ** ErrorHandling => takes in two error states and shows a message based on the error. Wraps main component to catch errors at the top.
 */

const ErrorHandling = ({ loadError }) => {
	return (
		<div>
			{loadError ? (
				<div className="load-error" aria-label="error">
					<p className="load-error__message align--center content-body padding__top--large padding__bottom--large">
						We are unable to reach the server at this time. Please check back
						later.
					</p>
				</div>
			) : null}
		</div>
	);
};

ErrorHandling.propTypes = {
	loadError: PropTypes.bool,
};

export default ErrorHandling;
